// store.ts
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { api } from './commonApi';
import { reducer as authReducer } from './auth/authSlice';
import { reducer as RestaurantReducer } from './restaurant/restaurantSlice';

const authPersistConfig = {
	key: 'auth',
	storage,
	whitelist: ['selectedRestaurantId'],
};

const rootReducer = combineReducers({
	[api.reducerPath]: api.reducer,
	auth: persistReducer(authPersistConfig, authReducer),
	restaurant: RestaurantReducer,
});

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(api.middleware),
	devTools: true,
});

export const persistor = persistStore(store);
